import { Skeleton } from "@mui/material";
import classNames from "classnames";

import styles from "./SkeletonCell.module.css";

/**
 * Cell content for a placeholder row. Decorative: the table's `aria-busy`
 * is what tells assistive tech it's loading.
 */
export function SkeletonCell({ className }: { className?: string }) {
  return (
    <span className={classNames(styles.cell, className)} aria-hidden="true">
      <Skeleton variant="rounded" animation="wave" className={styles.bar} />
    </span>
  );
}
